module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var call = __webpack_require__("c65b");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var hasOwn = __webpack_require__("1a2d");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "07fa":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("50c4");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d51":
/***/ (function(module, exports) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "13d2":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var DESCRIPTORS = __webpack_require__("83ab");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("5e77").CONFIGURABLE;
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "1626":
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var defineBuiltIn = __webpack_require__("cb2d");
var defineGlobalProperty = __webpack_require__("6374");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2ba4":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es-x/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "2dcf":
/***/ (function(module, exports) {

module.exports = require("query-string");

/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "3a9b":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ "40d5":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "485a":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.24.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.24.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "577e":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ "5926":
/***/ (function(module, exports, __webpack_require__) {

var trunc = __webpack_require__("b42e");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "59ed":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var tryToString = __webpack_require__("0d51");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5e77":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var hasOwn = __webpack_require__("1a2d");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "6374":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var hasOwn = __webpack_require__("1a2d");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7966":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = _interopRequireDefault(__webpack_require__("d887"));

var _merge = _interopRequireDefault(__webpack_require__("e409"));

var _isByteLength = _interopRequireDefault(__webpack_require__("f754"));

var _isFQDN = _interopRequireDefault(__webpack_require__("7f64"));

var _isIP = _interopRequireDefault(__webpack_require__("8476"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true,
  blacklisted_chars: '',
  ignore_max_length: false,
  host_blacklist: []
};
/* eslint-disable max-len */

/* eslint-disable no-control-regex */

var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var defaultMaxEmailLength = 254;
/* eslint-enable max-len */

/* eslint-enable no-control-regex */

/**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */

function validateDisplayName(display_name) {
  var display_name_without_quotes = display_name.replace(/^"(.+)"$/, '$1'); // display name with only spaces is not valid

  if (!display_name_without_quotes.trim()) {
    return false;
  } // check whether display name contains illegal character


  var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);

  if (contains_illegal) {
    // if contains illegal characters,
    // must to be enclosed in double-quotes, otherwise it's not a valid display name
    if (display_name_without_quotes === display_name) {
      return false;
    } // the quotes in display name must start with character symbol \


    var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;

    if (!all_start_with_back_slash) {
      return false;
    }
  }

  return true;
}

function isEmail(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(splitNameAddress);

    if (display_email) {
      var display_name = display_email[1]; // Remove display name and angle brackets to get email address
      // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)

      str = str.replace(display_name, '').replace(/(^<|>$)/g, ''); // sometimes need to trim the last space to get the display name
      // because there may be a space between display name and email address
      // eg. myname <address@gmail.com>
      // the display name is `myname` instead of `myname `, so need to trim the last space

      if (display_name.endsWith(' ')) {
        display_name = display_name.substr(0, display_name.length - 1);
      }

      if (!validateDisplayName(display_name)) {
        return false;
      }
    } else if (options.require_display_name) {
      return false;
    }
  }

  if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
    return false;
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var lower_domain = domain.toLowerCase();

  if (options.host_blacklist.includes(lower_domain)) {
    return false;
  }

  var user = parts.join('@');

  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
    /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */
    user = user.toLowerCase(); // Removing sub-address from username before gmail validation

    var username = user.split('+')[0]; // Dots are not included in gmail length restriction

    if (!(0, _isByteLength.default)(username.replace(/\./g, ''), {
      min: 6,
      max: 30
    })) {
      return false;
    }

    var _user_parts = username.split('.');

    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }

  if (options.ignore_max_length === false && (!(0, _isByteLength.default)(user, {
    max: 64
  }) || !(0, _isByteLength.default)(domain, {
    max: 254
  }))) {
    return false;
  }

  if (!(0, _isFQDN.default)(domain, {
    require_tld: options.require_tld
  })) {
    if (!options.allow_ip_domain) {
      return false;
    }

    if (!(0, _isIP.default)(domain)) {
      if (!domain.startsWith('[') || !domain.endsWith(']')) {
        return false;
      }

      var noBracketdomain = domain.substr(1, domain.length - 2);

      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
        return false;
      }
    }
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
  var user_parts = user.split('.');

  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }

  if (options.blacklisted_chars) {
    if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7f64":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFQDN;

var _assertString = _interopRequireDefault(__webpack_require__("d887"));

var _merge = _interopRequireDefault(__webpack_require__("e409"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_numeric_tld: false,
  allow_wildcard: false
};

function isFQDN(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_fqdn_options);
  /* Remove the optional trailing dot before checking validity */

  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  /* Remove the optional wildcard before checking validity */


  if (options.allow_wildcard === true && str.indexOf('*.') === 0) {
    str = str.substring(2);
  }

  var parts = str.split('.');
  var tld = parts[parts.length - 1];

  if (options.require_tld) {
    // disallow fqdns without tld
    if (parts.length < 2) {
      return false;
    }

    if (!/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    } // disallow spaces


    if (/\s/.test(tld)) {
      return false;
    }
  } // reject numeric TLDs


  if (!options.allow_numeric_tld && /^\d+$/.test(tld)) {
    return false;
  }

  return parts.every(function (part) {
    if (part.length > 63) {
      return false;
    }

    if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    } // disallow full-width chars


    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    } // disallow parts starting or ending with hyphen


    if (/^-|-$/.test(part)) {
      return false;
    }

    if (!options.allow_underscores && /_/.test(part)) {
      return false;
    }

    return true;
  });
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8476":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIP;

var _assertString = _interopRequireDefault(__webpack_require__("d887"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */
var IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
var IPv4AddressFormat = "(".concat(IPv4SegmentFormat, "[.]){3}").concat(IPv4SegmentFormat);
var IPv4AddressRegExp = new RegExp("^".concat(IPv4AddressFormat, "$"));
var IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})';
var IPv6AddressRegExp = new RegExp('^(' + "(?:".concat(IPv6SegmentFormat, ":){7}(?:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){6}(?:").concat(IPv4AddressFormat, "|:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){5}(?::").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){4}(?:(:").concat(IPv6SegmentFormat, "){0,1}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){3}(?:(:").concat(IPv6SegmentFormat, "){0,2}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){2}(?:(:").concat(IPv6SegmentFormat, "){0,3}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){1}(?:(:").concat(IPv6SegmentFormat, "){0,4}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat(IPv6SegmentFormat, "){0,5}:").concat(IPv4AddressFormat, "|(?::").concat(IPv6SegmentFormat, "){1,7}|:))") + ')(%[0-9a-zA-Z-.:]{1,})?$');

function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  }

  if (version === '4') {
    if (!IPv4AddressRegExp.test(str)) {
      return false;
    }

    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  }

  if (version === '6') {
    return !!IPv6AddressRegExp.test(str);
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),

/***/ "861d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var isCallable = __webpack_require__("1626");
var store = __webpack_require__("c6cd");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "90e3":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var anObject = __webpack_require__("825a");
var toPropertyKey = __webpack_require__("a04b");

var $TypeError = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "a04b":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("c04e");
var isSymbol = __webpack_require__("d9b5");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "ab36":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ "aeb0":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ "aed9":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "b42e":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var hasOwn = __webpack_require__("1a2d");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b980":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es-x/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var getMethod = __webpack_require__("dc4a");
var ordinaryToPrimitive = __webpack_require__("485a");
var wellKnownSymbol = __webpack_require__("b622");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c65b":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var defineGlobalProperty = __webpack_require__("6374");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c770":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "cb2d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var definePropertyModule = __webpack_require__("9bf2");
var makeBuiltIn = __webpack_require__("13d2");
var defineGlobalProperty = __webpack_require__("6374");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cebe":
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__("e330");
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d887":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    var invalidType = _typeof(input);

    if (input === null) invalidType = 'null';else if (invalidType === 'object') invalidType = input.constructor.name;
    throw new TypeError("Expected a string but received a ".concat(invalidType));
  }
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),

/***/ "d9b5":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "d9e2":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var wrapErrorConstructorWithCause = __webpack_require__("e5cb");

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://github.com/tc39/proposal-error-cause
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dc4a":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("59ed");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ "e330":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var uncurryThis = NATIVE_BIND && bind.bind(call, call);

module.exports = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis(fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "e391":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("577e");

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ "e409":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;

function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 ? arguments[1] : undefined;

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }

  return obj;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),

/***/ "e5cb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var hasOwn = __webpack_require__("1a2d");
var createNonEnumerableProperty = __webpack_require__("9112");
var isPrototypeOf = __webpack_require__("3a9b");
var setPrototypeOf = __webpack_require__("d2bb");
var copyConstructorProperties = __webpack_require__("e893");
var proxyAccessor = __webpack_require__("aeb0");
var inheritIfRequired = __webpack_require__("7156");
var normalizeStringArgument = __webpack_require__("e391");
var installErrorCause = __webpack_require__("ab36");
var clearErrorStack = __webpack_require__("c770");
var ERROR_STACK_INSTALLABLE = __webpack_require__("b980");
var DESCRIPTORS = __webpack_require__("83ab");
var IS_PURE = __webpack_require__("c430");

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(result, 'stack', clearErrorStack(result.stack, 2));
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var isCallable = __webpack_require__("1626");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "f754":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isByteLength;

var _assertString = _interopRequireDefault(__webpack_require__("d887"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }

  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "fae3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "identityApi", function() { return /* reexport */ identity_api; });
__webpack_require__.d(__webpack_exports__, "checkRedirect", function() { return /* reexport */ check_redirect; });
__webpack_require__.d(__webpack_exports__, "captchaMixin", function() { return /* reexport */ captcha_mixin; });
__webpack_require__.d(__webpack_exports__, "concentMixin", function() { return /* reexport */ concent_mixin; });
__webpack_require__.d(__webpack_exports__, "errorMixin", function() { return /* reexport */ error_mixin; });
__webpack_require__.d(__webpack_exports__, "errorUtilMixin", function() { return /* reexport */ error_util_mixin; });
__webpack_require__.d(__webpack_exports__, "loginMixin", function() { return /* reexport */ login_mixin; });
__webpack_require__.d(__webpack_exports__, "logoutMixin", function() { return /* reexport */ logout_mixin; });
__webpack_require__.d(__webpack_exports__, "noStateRedirectMixin", function() { return /* reexport */ no_state_redirect_mixin; });
__webpack_require__.d(__webpack_exports__, "postLogoutMixin", function() { return /* reexport */ post_logout_mixin; });
__webpack_require__.d(__webpack_exports__, "recoveryMixin", function() { return /* reexport */ recovery_mixin; });
__webpack_require__.d(__webpack_exports__, "registerMixin", function() { return /* reexport */ register_mixin; });
__webpack_require__.d(__webpack_exports__, "resetPasswordMixin", function() { return /* reexport */ reset_password_mixin; });
__webpack_require__.d(__webpack_exports__, "formMessageMixin", function() { return /* reexport */ form_message_mixin; });
__webpack_require__.d(__webpack_exports__, "account2Mixin", function() { return /* reexport */ account2_mixin; });
__webpack_require__.d(__webpack_exports__, "account2OptionsMixin", function() { return /* reexport */ account2_options_mixin; });
__webpack_require__.d(__webpack_exports__, "error2Mixin", function() { return /* reexport */ error2_mixin; });
__webpack_require__.d(__webpack_exports__, "consent2Mixin", function() { return /* reexport */ consent2_mixin; });
__webpack_require__.d(__webpack_exports__, "logout2Mixin", function() { return /* reexport */ logout2_mixin; });
__webpack_require__.d(__webpack_exports__, "manage2Mixin", function() { return /* reexport */ manage2_mixin; });
__webpack_require__.d(__webpack_exports__, "manage2PasswordMixin", function() { return /* reexport */ manage2_password_mixin; });
__webpack_require__.d(__webpack_exports__, "postLogout2Mixin", function() { return /* reexport */ post_logout2_mixin; });
__webpack_require__.d(__webpack_exports__, "httpError", function() { return /* reexport */ http_error_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "logger", function() { return /* reexport */ logger; });
__webpack_require__.d(__webpack_exports__, "formRedirect", function() { return /* reexport */ formRedirect; });

// NAMESPACE OBJECT: ./src/api/identity-api/const.js
var const_namespaceObject = {};
__webpack_require__.r(const_namespaceObject);
__webpack_require__.d(const_namespaceObject, "NO_STATE_REDIRECT_PATH", function() { return NO_STATE_REDIRECT_PATH; });
__webpack_require__.d(const_namespaceObject, "EXTERNAL_PROVIDER_ESIA_PATH", function() { return EXTERNAL_PROVIDER_ESIA_PATH; });
__webpack_require__.d(const_namespaceObject, "EXTERNAL_PROVIDER_PATH", function() { return EXTERNAL_PROVIDER_PATH; });
__webpack_require__.d(const_namespaceObject, "LOGOUT_PATH", function() { return LOGOUT_PATH; });
__webpack_require__.d(const_namespaceObject, "ACCOUNT2_RELOAD_PATH", function() { return ACCOUNT2_RELOAD_PATH; });
__webpack_require__.d(const_namespaceObject, "ACCOUNT2_RETURN_PATH", function() { return ACCOUNT2_RETURN_PATH; });
__webpack_require__.d(const_namespaceObject, "ACCOUNT2_SUBMIT_PATH", function() { return ACCOUNT2_SUBMIT_PATH; });
__webpack_require__.d(const_namespaceObject, "ACCOUNT2_LOGOUT_PATH", function() { return ACCOUNT2_LOGOUT_PATH; });

// NAMESPACE OBJECT: ./src/utils/http-error.js
var http_error_namespaceObject = {};
__webpack_require__.r(http_error_namespaceObject);
__webpack_require__.d(http_error_namespaceObject, "HTTP_UNAUTHORIZED", function() { return HTTP_UNAUTHORIZED; });
__webpack_require__.d(http_error_namespaceObject, "isUnauthorized", function() { return isUnauthorized; });
__webpack_require__.d(http_error_namespaceObject, "httpErrorIsUnauthorized", function() { return httpErrorIsUnauthorized; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./src/api/identity-api/const.js
const NO_STATE_REDIRECT_PATH = "account";
const EXTERNAL_PROVIDER_ESIA_PATH = "account/external/esia";
const EXTERNAL_PROVIDER_PATH = "account/external";
const LOGOUT_PATH = "account/logout";
const ACCOUNT2_RELOAD_PATH = "account2/reload";
const ACCOUNT2_RETURN_PATH = "account2/return";
const ACCOUNT2_SUBMIT_PATH = "account2/submit";
const ACCOUNT2_LOGOUT_PATH = "account2/logout";
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("d9e2");

// EXTERNAL MODULE: external "axios"
var external_axios_ = __webpack_require__("cebe");
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_);

// CONCATENATED MODULE: ./src/api/identity-api/repository.js


let axiosInstance = null;
const configure = baseURL => {
  axiosInstance = external_axios_default.a.create({
    baseURL,
    withCredentials: true
  });
};
/* harmony default export */ var repository = ({
  get instance() {
    if (!axiosInstance) {
      throw new Error("This repository not configured. Call configure method.");
    }

    return axiosInstance;
  }

});
// CONCATENATED MODULE: ./src/api/identity-api/login.js

/* harmony default export */ var identity_api_login = ({
  getInfo: async (state = null, cancelToken = null) => (await repository.instance.get("account/login", {
    params: {
      state
    },
    cancelToken
  })).data,
  post: async (state, login, password, rememberMe, captchaResult = null, cancelToken = null, alias = null) => (await repository.instance.post(`account/login${alias ? `/${encodeURIComponent(alias)}` : ''}`, {
    state,
    login,
    password,
    rememberMe,
    captcha: captchaResult ? {
      key: null,
      result: captchaResult
    } : null
  }, {
    cancelToken
  })).data
});
// CONCATENATED MODULE: ./src/api/identity-api/concent.js

/* harmony default export */ var concent = ({
  getInfo: async (state, cancelToken = null) => (await repository.instance.get("account/concent", {
    params: {
      state
    },
    cancelToken
  })).data,
  cancel: (state, cancelToken = null) => repository.instance.post("account/concent/cancel", {
    state
  }, {
    cancelToken
  }),
  submit: (state, scopes, rememberDecision, cancelToken = null) => repository.instance.post("account/concent", {
    state,
    scopes,
    rememberConcents: rememberDecision
  }, {
    cancelToken
  })
});
// CONCATENATED MODULE: ./src/api/identity-api/error.js

/* harmony default export */ var error = ({
  getInfo: async (state, cancelToken = null) => (await repository.instance.get("account/error", {
    params: {
      state
    },
    cancelToken
  })).data
});
// CONCATENATED MODULE: ./src/api/identity-api/logout.js

/* harmony default export */ var logout = ({
  getInfo: async (state = null, cancelToken = null) => (await repository.instance.get("account/logout", {
    params: {
      state
    },
    cancelToken
  })).data,
  getPostLogoutInfo: async (state, cancelToken = null) => (await repository.instance.get("account/signout", {
    params: {
      state
    },
    cancelToken
  })).data
});
// CONCATENATED MODULE: ./src/api/identity-api/register.js

/* harmony default export */ var register = ({
  getInfo: async (state = null, cancelToken = null) => (await repository.instance.get("account/register/std", {
    params: {
      state
    },
    withCredentials: true,
    cancelToken
  })).data,
  post: (state, firstName, lastName, email, password, captchaResult = null, cancelToken = null) => repository.instance.post("account/register/std", {
    state,
    firstName,
    lastName,
    email,
    password,
    captcha: captchaResult ? {
      key: null,
      result: captchaResult
    } : null
  }, {
    withCredentials: true,
    cancelToken
  })
});
// CONCATENATED MODULE: ./src/api/identity-api/reset-password.js

/* harmony default export */ var reset_password = ({
  getInfo: async (state = null, cancelToken = null) => (await repository.instance.get("account/resetpassword", {
    params: {
      state
    },
    cancelToken
  })).data,
  sendEmail: (state, email, cancelToken = null) => repository.instance.post("account/resetpassword", {
    State: state,
    Email: email
  }, {
    cancelToken
  }),
  updatePassword: (state, newPassword, cancelToken = null) => repository.instance.put("account/resetpassword", {
    State: state,
    NewPassword: newPassword
  }, {
    cancelToken
  })
});
// CONCATENATED MODULE: ./src/api/identity-api/captcha.js

/* harmony default export */ var identity_api_captcha = ({
  generate: async (width, height, key = null, cancelToken = null) => (await repository.instance.post("captcha", {
    width,
    height,
    key
  }, {
    cancelToken
  })).data,
  validate: async (captchaId, value, cancelToken = null) => (await repository.instance.patch("captcha", {
    captcha: captchaId,
    value
  }, {
    cancelToken
  })).data
});
// CONCATENATED MODULE: ./src/utils/form-redirect.js
const createHiddenInput = (name, value) => {
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = name;
  input.value = value;
  return input;
};

const createForm = (url, params = {}) => {
  const form = document.createElement("form");
  form.style.position = "absolute";
  form.action = url;
  form.method = "POST";
  form.enctype = "application/x-www-form-urlencoded";
  Object.keys(params).forEach(key => {
    if (params[key] !== null && params[key] !== undefined) {
      form.appendChild(createHiddenInput(key, params[key]));
    }
  });
  return form;
};

function formRedirect(url, params = {}) {
  if (!document.body) return false;
  const form = createForm(url, params);
  document.body.appendChild(form);
  form.submit();
}
// CONCATENATED MODULE: ./src/api/identity-api/account2.js



/* harmony default export */ var account2 = ({
  createToken: async (state, cancelToken = null) => (await repository.instance.post("account2/token", {
    state
  }, {
    cancelToken,
    withCredentials: true
  })).data,
  getOptions: async (state, cancelToken = null) => (await repository.instance.get("account2/options", {
    params: {
      state
    },
    cancelToken
  })).data,

  reloadRedirect(state, token) {
    const url = `${repository.instance.defaults.baseURL}/${ACCOUNT2_RELOAD_PATH}`;
    formRedirect(url, {
      state,
      token
    });
  },

  returnRedirect(state, token) {
    const url = `${repository.instance.defaults.baseURL}/${ACCOUNT2_RETURN_PATH}`;
    formRedirect(url, {
      state,
      token
    });
  },

  submitRedirect(state, token) {
    const url = `${repository.instance.defaults.baseURL}/${ACCOUNT2_SUBMIT_PATH}`;
    formRedirect(url, {
      state,
      token
    });
  },

  logoutRedirect(state, token) {
    const url = `${repository.instance.defaults.baseURL}/${ACCOUNT2_LOGOUT_PATH}`;
    formRedirect(url, {
      state,
      token
    });
  }

});
// CONCATENATED MODULE: ./src/api/identity-api/manage2.js

/* harmony default export */ var manage2 = ({
  getInfo: async (bearerToken, state = null, cancelToken = null) => (await repository.instance.get("account2/manage", {
    params: {
      state
    },
    headers: {
      Authorization: `Bearer ${bearerToken}`
    },
    cancelToken,
    withCredentials: true
  })).data,
  changePassword: (oldPassword, newPassword, bearerToken, cancelToken = null) => repository.instance.post("account2/manage/password", {
    oldPassword,
    newPassword
  }, {
    headers: {
      Authorization: `Bearer ${bearerToken}`
    },
    cancelToken,
    withCredentials: true
  }),
  setNewPassword: (newPassword, bearerToken, cancelToken = null) => repository.instance.put("account2/manage/password", {
    newPassword
  }, {
    headers: {
      Authorization: `Bearer ${bearerToken}`
    },
    cancelToken,
    withCredentials: true
  })
});
// CONCATENATED MODULE: ./src/api/identity-api/consent2.js

/* harmony default export */ var consent2 = ({
  getInfo: async (bearerToken, state, cancelToken = null) => (await repository.instance.get("account2/consent", {
    params: {
      state
    },
    headers: {
      Authorization: `Bearer ${bearerToken}`
    },
    withCredentials: true,
    cancelToken
  })).data,
  post: (bearerToken, state, scopes, rememberDecision, cancelToken = null) => repository.instance.post("account2/consent", {
    state,
    scopes,
    rememberConcents: rememberDecision
  }, {
    headers: {
      Authorization: `Bearer ${bearerToken}`
    },
    withCredentials: true,
    cancelToken
  })
});
// CONCATENATED MODULE: ./src/api/identity-api/error2.js

/* harmony default export */ var error2 = ({
  getInfo: async (state, cancelToken = null) => (await repository.instance.get("account2/error", {
    params: {
      state
    },
    withCredentials: true,
    cancelToken
  })).data
});
// CONCATENATED MODULE: ./src/api/identity-api/logout2.js

/* harmony default export */ var logout2 = ({
  getInfo: async (bearerToken, state = null, cancelToken = null) => (await repository.instance.get("account2/logout", {
    params: {
      state
    },
    headers: {
      Authorization: `Bearer ${bearerToken}`
    },
    withCredentials: true,
    cancelToken
  })).data,
  getPostLogoutInfo: async (bearerToken, state, cancelToken = null) => (await repository.instance.get("account2/signout", {
    params: {
      state
    },
    headers: {
      Authorization: `Bearer ${bearerToken}`
    },
    withCredentials: true,
    cancelToken
  })).data
});
// CONCATENATED MODULE: ./src/api/identity-api/index.js

 // v1







 // v2






/* harmony default export */ var identity_api = ({
  configure: configure,
  repository: repository,
  Const: const_namespaceObject,
  login: identity_api_login,
  concent: concent,
  error: error,
  logout: logout,
  register: register,
  resetPassword: reset_password,
  captcha: identity_api_captcha,
  manage: manage2,
  account2: account2,
  manage2: manage2,
  consent2: consent2,
  error2: error2,
  logout2: logout2
});
// CONCATENATED MODULE: ./src/api/index.js


// EXTERNAL MODULE: external "query-string"
var external_query_string_ = __webpack_require__("2dcf");
var external_query_string_default = /*#__PURE__*/__webpack_require__.n(external_query_string_);

// CONCATENATED MODULE: ./src/mixins/check-redirect.js


/* harmony default export */ var check_redirect = (() => {
  const query = external_query_string_default.a.parse(location.search) || {};

  if (!query.state) {
    const baseUrl = identity_api.repository.instance.defaults.baseURL;
    const url = `${baseUrl}/${identity_api.Const.NO_STATE_REDIRECT_PATH}`;
    window.location.href = url;
    return true;
  }

  return false;
});
// CONCATENATED MODULE: ./src/utils/logger.js
/* harmony default export */ var logger = ({
  error: messageOrError => {
    if (console.error) {
      console.error(messageOrError);
    } else if (console.log) {
      console.log(messageOrError);
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/captcha-mixin.js


/* harmony default export */ var captcha_mixin = ({
  props: {
    result: {
      type: String,
      default: null
    },
    refresh: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      captchaImageDataUrl: null,
      captchaFormCode: null,
      captchaIsValid: null,
      captchaImageWidth: 90,
      captchaImageHeight: 42,
      captchaCodeValidateLength: 1,
      captchaId: null
    };
  },

  computed: {
    captchaImageSizeStyle() {
      return {
        width: this.captchaImageWidth > 0 ? `${this.captchaImageWidth}px` : 'auto',
        height: this.captchaImageHeight > 0 ? `${this.captchaImageHeight}px` : 'auto'
      };
    }

  },
  watch: {
    refresh() {
      if (this.refresh) {
        this.refreshCaptcha();
      }
    },

    captchaFormCode() {
      if (this.captchaFormCode) {
        if (this.captchaFormCode.length >= this.captchaCodeValidateLength) {
          this.validateCaptcha();
        }
      } else {
        this.captchaIsValid = null;
      }
    }

  },

  created() {
    if (this.refresh) {
      this.refreshCaptcha();
    }
  },

  methods: {
    async generateCaptcha() {
      try {
        const {
          captcha,
          image
        } = await identity_api.captcha.generate(this.captchaImageWidth, this.captchaImageHeight);
        this.captchaImageDataUrl = image;
        this.captchaId = captcha;
      } catch (e) {
        logger.error(e);
        this.captchaImageDataUrl = null;
        this.captchaId = null;
      }
    },

    async validateCaptcha() {
      try {
        const {
          success,
          result
        } = await identity_api.captcha.validate(this.captchaId, this.captchaFormCode);
        this.captchaIsValid = !!success;
        this.$emit("update:result", result);
      } catch (e) {
        logger.error(e);
        this.captchaImageDataUrl = null;
        this.captchaId = null;
      }
    },

    refreshCaptcha() {
      this.$emit("update:refresh", false);
      this.$emit("update:result", null);
      this.captchaFormCode = null;
      this.captchaIsValid = null;
      this.captchaId = null;
      this.generateCaptcha();
    }

  }
});
// CONCATENATED MODULE: ./src/utils/http-error.js
const HTTP_UNAUTHORIZED = 401;
const isUnauthorized = httpStatus => httpStatus === HTTP_UNAUTHORIZED;
const httpErrorIsUnauthorized = error => error && error.response && error.response.status && isUnauthorized(error.response.status);
// CONCATENATED MODULE: ./src/mixins/concent-mixin.js




/* harmony default export */ var concent_mixin = ({
  props: {
    state: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: true,
      error: false,
      concentInfo: null,
      formLoading: false,
      formError: false,
      form: {
        checkedIdentityScopes: [],
        checkedApiScopes: [],
        rememberDecision: false
      }
    };
  },

  computed: {
    concentCheckedScopes() {
      return this.form.checkedIdentityScopes.concat(this.form.checkedApiScopes);
    },

    concentClientName() {
      var _this$concentInfo$cli, _this$concentInfo;

      return (_this$concentInfo$cli = (_this$concentInfo = this.concentInfo) === null || _this$concentInfo === void 0 ? void 0 : _this$concentInfo.clientName) !== null && _this$concentInfo$cli !== void 0 ? _this$concentInfo$cli : "";
    },

    concentCanRemember() {
      var _this$concentInfo$can, _this$concentInfo2;

      return (_this$concentInfo$can = (_this$concentInfo2 = this.concentInfo) === null || _this$concentInfo2 === void 0 ? void 0 : _this$concentInfo2.canRememberConcents) !== null && _this$concentInfo$can !== void 0 ? _this$concentInfo$can : false;
    },

    concentIdentityScopes() {
      var _this$concentInfo$ide, _this$concentInfo3;

      return (_this$concentInfo$ide = (_this$concentInfo3 = this.concentInfo) === null || _this$concentInfo3 === void 0 ? void 0 : _this$concentInfo3.identityScopes) !== null && _this$concentInfo$ide !== void 0 ? _this$concentInfo$ide : [];
    },

    concentApiScopes() {
      var _this$concentInfo$api, _this$concentInfo4;

      return (_this$concentInfo$api = (_this$concentInfo4 = this.concentInfo) === null || _this$concentInfo4 === void 0 ? void 0 : _this$concentInfo4.apiScopes) !== null && _this$concentInfo$api !== void 0 ? _this$concentInfo$api : [];
    }

  },

  created() {
    if (!check_redirect()) {
      this.fetchConcentInfo(this.state);
    }
  },

  methods: {
    async fetchConcentInfo(state) {
      try {
        this.loading = true;
        this.concentInfo = await identity_api.concent.getInfo(state);
        this.loading = false;

        this._concentUpdateDefaultFormValues();
      } catch (e) {
        if (httpErrorIsUnauthorized(e)) {
          this.$router.replace({
            name: "login",
            query: {
              state: this.state
            }
          });
          return;
        }

        logger.error(e);
        this.error = true;
        this.loading = false;
      }
    },

    async concentAllow() {
      try {
        this.formLoading = true;
        this.formError = false;
        await identity_api.concent.submit(this.state, this.concentCheckedScopes, this.form.rememberDecision);
        this.concentPostRedirect();
      } catch (e) {
        logger.error(e);
        this.formLoading = false;
        this.formError = true;
      }
    },

    async concentCancel() {
      try {
        this.formLoading = true;
        this.formError = false;
        await identity_api.concent.cancel(this.state);
        this.concentPostRedirect();
      } catch (e) {
        logger.error(e);
        this.formError = true;
      } finally {
        this.formLoading = false;
      }
    },

    _concentUpdateDefaultFormValues() {
      var _this$concentInfo$ide2, _this$concentInfo5, _this$concentInfo$api2, _this$concentInfo6;

      this.form.checkedIdentityScopes = this._concentRequiredAllScopes((_this$concentInfo$ide2 = (_this$concentInfo5 = this.concentInfo) === null || _this$concentInfo5 === void 0 ? void 0 : _this$concentInfo5.identityScopes) !== null && _this$concentInfo$ide2 !== void 0 ? _this$concentInfo$ide2 : []);
      this.form.checkedApiScopes = this._concentRequiredAllScopes((_this$concentInfo$api2 = (_this$concentInfo6 = this.concentInfo) === null || _this$concentInfo6 === void 0 ? void 0 : _this$concentInfo6.apiScopes) !== null && _this$concentInfo$api2 !== void 0 ? _this$concentInfo$api2 : []);
      this.form.rememberDecision = this.concentCanRemember;
    },

    _concentRequiredScopes(scopes) {
      return scopes.filter(s => s.required).map(s => s.name);
    },

    _concentRequiredAllScopes(scopes) {
      return scopes.map(s => s.name);
    },

    concentPostRedirect() {
      var _this$concentInfo7;

      if ((_this$concentInfo7 = this.concentInfo) !== null && _this$concentInfo7 !== void 0 && _this$concentInfo7.redirectUri) {
        window.location.href = this.concentInfo.redirectUri;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/error-mixin.js



/* harmony default export */ var error_mixin = ({
  props: {
    state: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: true,
      error: false,
      errorInfo: null
    };
  },

  created() {
    if (!check_redirect()) {
      this.fetchErrorInfo(this.state);
    }
  },

  computed: {
    canBackUri() {
      var _this$errorInfo;

      return !!((_this$errorInfo = this.errorInfo) !== null && _this$errorInfo !== void 0 && _this$errorInfo.redirectUri);
    }

  },
  methods: {
    async fetchErrorInfo(state) {
      try {
        var _this$errorInfo2;

        this.loading = true;
        this.errorInfo = await identity_api.error.getInfo(state);
        logger.error((_this$errorInfo2 = this.errorInfo) === null || _this$errorInfo2 === void 0 ? void 0 : _this$errorInfo2.error);
      } catch (e) {
        logger.error(e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },

    backRedirect() {
      var _this$errorInfo3;

      if ((_this$errorInfo3 = this.errorInfo) !== null && _this$errorInfo3 !== void 0 && _this$errorInfo3.redirectUri) {
        window.location.href = this.errorInfo.redirectUri;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/error-util-mixin.js

/* harmony default export */ var error_util_mixin = ({
  methods: {
    getErrorBackUrl(state) {
      const baseUrl = identity_api.repository.instance.defaults.baseURL;
      const redirectPath = identity_api.Const.NO_STATE_REDIRECT_PATH;
      return identity_api.repository.instance.getUri({
        url: `${baseUrl}/${redirectPath}`,
        params: {
          state
        }
      });
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/form-message-mixin.js
/* harmony default export */ var form_message_mixin = ({
  data() {
    return {
      formErrorObject: null
    };
  },

  computed: {
    formFieldMessages() {
      return this.parseFormMessagesFromError(this.formErrorObject);
    },

    formFieldMessage() {
      return this.formFieldMessages[0];
    }

  },
  methods: {
    parseFormMessagesFromError(err) {
      var _err$response;

      const data = err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.data;
      if (!data) return [];
      if (!this.formMessages) return [];
      const {
        model,
        status
      } = data;
      const byStatus = this.formMessages[status];
      if (!byStatus) return [];

      if (typeof byStatus === "string") {
        return [byStatus];
      }

      if (!model) return [];
      const result = [];

      for (const [key, value] of Object.entries(model)) {
        if (typeof byStatus[key] === "string") {
          result.push(byStatus[key]);
        } else if (byStatus[key] && Array.isArray(value)) {
          for (const val of value) {
            if (typeof byStatus[key][val] === "string") {
              result.push(byStatus[key][val]);
            }
          }
        }
      }

      return result;
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/login-mixin.js




/* harmony default export */ var login_mixin = ({
  mixins: [form_message_mixin],
  props: {
    state: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: true,
      error: false,
      loginInfo: null,
      showCaptcha: false,
      refreshCaptcha: false,
      captchResult: null,
      formLoading: false,
      formError: false,
      formSuccess: false,
      form: {
        username: "",
        password: "",
        rememberMe: false,
        alias: null
      }
    };
  },

  created() {
    if (!check_redirect()) {
      this.fetchLoginInfo(this.state);
    }
  },

  methods: {
    async fetchLoginInfo(state) {
      try {
        this.loading = true;
        this.loginInfo = await identity_api.login.getInfo(state);
      } catch (e) {
        logger.error(e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },

    getEsiaProviderUrl() {
      const baseUrl = identity_api.repository.instance.defaults.baseURL;
      const esiaPath = identity_api.Const.EXTERNAL_PROVIDER_ESIA_PATH;
      return `${baseUrl}/${esiaPath}`;
    },

    getExternalProviderUrl(alias) {
      const baseUrl = identity_api.repository.instance.defaults.baseURL;
      const externalPath = identity_api.Const.EXTERNAL_PROVIDER_PATH;
      return `${baseUrl}/${externalPath}/${encodeURIComponent(alias)}`;
    },

    loginFormSubmit() {
      if (this.loginFormIsValid()) {
        const {
          username,
          password,
          rememberMe,
          alias
        } = this.form;
        this.performLogin(username, password, rememberMe, alias);
      }
    },

    loginFormIsValid() {
      return !!this.form.username && !!this.form.password;
    },

    async performLogin(username, password, rememberMe, alias = null) {
      try {
        this.formLoading = true;
        this.formError = false;
        this.formSuccess = false;
        this.formErrorObject = null;
        await identity_api.login.post(this.state, username, password, rememberMe, this.captchResult, null, alias);

        if (this.canLoginPostRedirect()) {
          this.loginPostRedirect();
        } else {
          this.formSuccess = true;
          this.formLoading = false;
          this.showCaptcha = false;
        }
      } catch (e) {
        logger.error(e);
        this.formErrorObject = e;
        this.formError = true;
        this.formLoading = false;
        this.showCaptcha = true;
        this.refreshCaptcha = true;
      }
    },

    canLoginPostRedirect() {
      var _this$loginInfo;

      return !!((_this$loginInfo = this.loginInfo) !== null && _this$loginInfo !== void 0 && _this$loginInfo.redirectUri);
    },

    loginPostRedirect() {
      var _this$loginInfo2;

      if ((_this$loginInfo2 = this.loginInfo) !== null && _this$loginInfo2 !== void 0 && _this$loginInfo2.redirectUri) {
        window.location.href = this.loginInfo.redirectUri;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/logout-mixin.js




/* harmony default export */ var logout_mixin = ({
  props: {
    state: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: true,
      error: false,
      logoutInfo: null
    };
  },

  created() {
    if (!check_redirect()) {
      this.fetchLogoutInfo(this.state);
    }
  },

  computed: {
    logoutUrl() {
      const baseUrl = identity_api.repository.instance.defaults.baseURL;
      const logoutPath = identity_api.Const.LOGOUT_PATH;
      return identity_api.repository.instance.getUri({
        url: `${baseUrl}/${logoutPath}`
      });
    },

    logoutState() {
      var _this$logoutInfo;

      return (_this$logoutInfo = this.logoutInfo) === null || _this$logoutInfo === void 0 ? void 0 : _this$logoutInfo.logoutState;
    },

    isAutoLogout() {
      var _this$logoutInfo2;

      return !((_this$logoutInfo2 = this.logoutInfo) !== null && _this$logoutInfo2 !== void 0 && _this$logoutInfo2.showLogoutPrompt);
    }

  },
  methods: {
    async fetchLogoutInfo(state) {
      try {
        this.loading = true;
        this.logoutInfo = await identity_api.logout.getInfo(state);
        this.loading = false;

        if (this.isAutoLogout) {
          this.$nextTick(this.performAutoLogout);
        }
      } catch (e) {
        if (httpErrorIsUnauthorized(e)) {
          this.$router.replace({
            name: "login",
            query: {
              state: this.state
            }
          });
          return;
        }

        logger.error(e);
        this.error = true;
        this.loading = false;
      }
    },

    performAutoLogout() {
      if (this.$refs.logoutForm) {
        this.$refs.logoutForm.submit();
      }
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/no-state-redirect-mixin.js

/* harmony default export */ var no_state_redirect_mixin = ({
  created() {
    check_redirect();
  }

});
// CONCATENATED MODULE: ./src/mixins/post-logout-mixin.js




const REDIRECT_DELAY = 1000;
/* harmony default export */ var post_logout_mixin = ({
  props: {
    state: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: true,
      error: false,
      postLogoutInfo: null
    };
  },

  created() {
    if (!check_redirect()) {
      this.fetchPostLogoutInfo(this.state);
    }
  },

  methods: {
    async fetchPostLogoutInfo(state) {
      try {
        this.loading = true;
        this.postLogoutInfo = await identity_api.logout.getPostLogoutInfo(state);
        this.loading = false;
        this.$nextTick(() => {
          if (this.postLogoutInfo) {
            this.handlePostLogout(this.postLogoutInfo);
          }
        });
      } catch (e) {
        if (httpErrorIsUnauthorized(e)) {
          this.$router.replace({
            name: "login",
            query: {
              state: this.state
            }
          });
          return;
        }

        logger.error(e);
        this.error = true;
        this.loading = false;
      }
    },

    handlePostLogout({
      frameUrl,
      postLogoutUrl
    }) {
      if (!frameUrl) {
        this.postLogoutRedirectTo(postLogoutUrl);
      } else {
        this.iframePostLogout(frameUrl, postLogoutUrl);
      }
    },

    iframePostLogout(frameUrl, postLogoutUrl) {
      if (!this.$el) {
        this.postLogoutRedirectTo(postLogoutUrl);
        return;
      }

      const iframe = this._createIframe(frameUrl, () => {
        this.postLogoutRedirectWithDelay(postLogoutUrl, REDIRECT_DELAY);
      });

      this.$el.appendChild(iframe);
    },

    _createIframe(frameUrl, onLoad) {
      const iframe = document.createElement("iframe");
      iframe.onload = onLoad;
      iframe.src = frameUrl;
      iframe.style.width = "0px";
      iframe.style.height = "0px";
      iframe.style.display = "none";
      return iframe;
    },

    postLogoutRedirectWithDelay(url, delay) {
      setTimeout(() => {
        this.postLogoutRedirectTo(url);
      }, delay);
    },

    postLogoutRedirectTo(url) {
      if (url) {
        window.location.href = url;
      } else {
        this.$router.replace({
          name: "login",
          query: {
            state: this.state
          }
        });
      }
    }

  }
});
// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("7966");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// CONCATENATED MODULE: ./src/mixins/recovery-mixin.js




/* harmony default export */ var recovery_mixin = ({
  props: {
    state: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: true,
      error: false,
      recoveryInfo: null,
      formLoading: false,
      formError: false,
      formSuccess: false,
      formFieldsRequired: false,
      formInvalidEmail: false,
      form: {
        email: ""
      }
    };
  },

  computed: {
    trimmedEmail() {
      return (this.form.email || "").trim();
    }

  },

  created() {
    if (!check_redirect()) {
      this.fetchRecoveryInfo(this.state);
    }
  },

  methods: {
    async fetchRecoveryInfo(state) {
      try {
        this.loading = true;
        this.recoveryInfo = await identity_api.login.getInfo(state);
      } catch (e) {
        logger.error(e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },

    recoveryFormSubmit() {
      if (this.recoveryFormIsValid()) {
        this.performSendEmail(this.state, this.trimmedEmail);
      }
    },

    async performSendEmail(state, email) {
      try {
        this.formLoading = true;
        await identity_api.resetPassword.sendEmail(state, email);
        this.formSuccess = true;
        this.resetRecoveryForm();
      } catch (e) {
        logger.error(e);
        this.formError = true;
      } finally {
        this.formLoading = false;
      }
    },

    resetRecoveryForm() {
      this.form.email = "";
    },

    resetRecoveryFormMessage() {
      this.formError = false;
      this.formSuccess = false;
      this.formFieldsRequired = false;
      this.formInvalidEmail = false;
    },

    recoveryFormIsValid() {
      this.resetRecoveryFormMessage();
      let isValid = true;
      isValid = isValid && this.validateEmpty();
      isValid = isValid && this.validateEmail();
      return isValid;
    },

    validateEmpty() {
      const isValid = !!this.form.email;

      if (!isValid) {
        this.formFieldsRequired = true;
      }

      return isValid;
    },

    validateEmail() {
      const isValid = isEmail_default()(this.trimmedEmail);

      if (!isValid) {
        this.formInvalidEmail = true;
      }

      return isValid;
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/register-mixin.js





/* harmony default export */ var register_mixin = ({
  mixins: [form_message_mixin],
  props: {
    state: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: true,
      error: false,
      registerInfo: null,
      showCaptcha: false,
      refreshCaptcha: false,
      captchResult: null,
      formLoading: false,
      formError: false,
      formSuccess: false,
      formFieldsRequired: false,
      formInvalidEmail: false,
      formInvalidComparePassword: false,
      form: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        repeatPassword: ""
      }
    };
  },

  computed: {
    trimmedFirstName() {
      return (this.form.firstName || "").trim();
    },

    trimmedLastName() {
      return (this.form.lastName || "").trim();
    },

    trimmedEmail() {
      return (this.form.email || "").trim();
    }

  },

  created() {
    if (!check_redirect()) {
      this.fetchRegisterInfo(this.state);
    }
  },

  methods: {
    async fetchRegisterInfo(state) {
      try {
        this.loading = true;
        this.registerInfo = await identity_api.login.getInfo(state);
      } catch (e) {
        logger.error(e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },

    registerFormSubmit() {
      if (this.registerFormIsValid()) {
        this.performRegister(this.trimmedFirstName, this.trimmedLastName, this.trimmedEmail, this.form.password);
      }
    },

    async performRegister(firstName, lastName, email, password) {
      try {
        this.formLoading = true;
        await identity_api.register.post(this.state, firstName, lastName, email, password, this.captchResult);
        this.formSuccess = true;
        this.showCaptcha = false;
        this.resetRegisterForm();
        this.registerPostRedirect();
      } catch (e) {
        logger.error(e);
        this.formErrorObject = e;
        this.formError = true;
        this.showCaptcha = true;
        this.refreshCaptcha = true;
      } finally {
        this.formLoading = false;
      }
    },

    resetRegisterForm() {
      this.form.firstName = "";
      this.form.lastName = "";
      this.form.email = "";
      this.form.password = "";
      this.form.repeatPassword = "";
    },

    resetRegisterFormMessage() {
      this.formError = false;
      this.formErrorObject = null;
      this.formSuccess = false;
      this.formFieldsRequired = false;
      this.formInvalidEmail = false;
      this.formInvalidComparePassword = false;
    },

    registerFormIsValid() {
      this.resetRegisterFormMessage();
      let isValid = true;
      isValid = isValid && this.validateEmpty();
      isValid = isValid && this.validateEmail();
      isValid = isValid && this.validatePassword();
      return isValid;
    },

    validateEmpty() {
      const isValid = !!this.trimmedFirstName && !!this.trimmedLastName && !!this.form.email && !!this.form.password;

      if (!isValid) {
        this.formFieldsRequired = true;
      }

      return isValid;
    },

    validateEmail() {
      const isValid = isEmail_default()(this.trimmedEmail);

      if (!isValid) {
        this.formInvalidEmail = true;
      }

      return isValid;
    },

    validatePassword() {
      const isValid = this.form.password === this.form.repeatPassword;

      if (!isValid) {
        this.formInvalidComparePassword = true;
      }

      return isValid;
    },

    registerPostRedirect() {
      var _this$registerInfo;

      if ((_this$registerInfo = this.registerInfo) !== null && _this$registerInfo !== void 0 && _this$registerInfo.redirectUri) {
        window.location.href = this.registerInfo.redirectUri;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/reset-password-mixin.js




/* harmony default export */ var reset_password_mixin = ({
  mixins: [form_message_mixin],
  props: {
    state: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: true,
      error: false,
      resetPasswordInfo: null,
      formLoading: false,
      formError: false,
      formSuccess: false,
      formFieldsRequired: false,
      formInvalidComparePassword: false,
      form: {
        password: "",
        repeatPassword: ""
      }
    };
  },

  computed: {
    userEmail() {
      var _this$resetPasswordIn;

      return (_this$resetPasswordIn = this.resetPasswordInfo) === null || _this$resetPasswordIn === void 0 ? void 0 : _this$resetPasswordIn.Email;
    }

  },

  created() {
    if (!check_redirect()) {
      this.fetchResetPasswordInfo(this.state);
    }
  },

  methods: {
    async fetchResetPasswordInfo(state) {
      try {
        this.loading = true;
        this.resetPasswordInfo = await identity_api.resetPassword.getInfo(state);
      } catch (e) {
        logger.error(e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },

    resetPasswordFormSubmit() {
      if (this.resetPasswordFormIsValid()) {
        this.performUpdatePassword(this.state, this.form.password);
      }
    },

    async performUpdatePassword(state, password) {
      try {
        this.formLoading = true;
        await identity_api.resetPassword.updatePassword(state, password);
        this.formSuccess = true;
        this.resetPasswordForm();
      } catch (e) {
        logger.error(e);
        this.formError = true;
        this.formErrorObject = e;
      } finally {
        this.formLoading = false;
      }
    },

    resetPasswordForm() {
      this.form.password = "";
      this.form.repeatPassword = "";
    },

    resetPasswordFormMessage() {
      this.formError = false;
      this.formErrorObject = null;
      this.formSuccess = false;
      this.formFieldsRequired = false;
      this.formInvalidComparePassword = false;
    },

    resetPasswordFormIsValid() {
      this.resetPasswordFormMessage();
      let isValid = true;
      isValid = isValid && this.validateEmpty();
      isValid = isValid && this.validatePassword();
      return isValid;
    },

    validateEmpty() {
      const isValid = !!this.form.repeatPassword && !!this.form.password;

      if (!isValid) {
        this.formFieldsRequired = true;
      }

      return isValid;
    },

    validatePassword() {
      const isValid = this.form.password === this.form.repeatPassword;

      if (!isValid) {
        this.formInvalidComparePassword = true;
      }

      return isValid;
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/account2-mixin.js




/* harmony default export */ var account2_mixin = ({
  props: {
    state: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      tokenLoading: false,
      tokenError: false,
      token: null
    };
  },

  created() {
    if (!check_redirect()) {
      this.fetchToken();
    }
  },

  methods: {
    async fetchToken() {
      try {
        this.tokenLoading = true;
        this.tokenError = false;
        const tokenResponse = await identity_api.account2.createToken(this.state);

        if (!tokenResponse.token) {
          throw new Error("Token creation request returns empty token");
        }

        this.token = tokenResponse.token;
        this.tokenLoading = false;
      } catch (e) {
        logger.error(e);
        this.tokenLoading = false;

        try {
          this.reloadRedirect();
        } catch (e2) {
          logger.error(e2);
          this.tokenError = true;
        }
      }
    },

    returnRedirect() {
      identity_api.account2.returnRedirect(this.state, this.token);
    },

    reloadRedirect() {
      identity_api.account2.reloadRedirect(this.state, this.token);
    },

    submitRedirect() {
      identity_api.account2.submitRedirect(this.state, this.token);
    },

    logoutRedirect() {
      identity_api.account2.logoutRedirect(this.state, this.token);
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/error2-mixin.js



/* harmony default export */ var error2_mixin = ({
  props: {
    state: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: true,
      error: false,
      errorInfo: null
    };
  },

  created() {
    if (!check_redirect()) {
      this.fetchErrorInfo();
    }
  },

  methods: {
    async fetchErrorInfo() {
      try {
        var _this$errorInfo;

        this.loading = true;
        this.error = false;
        this.errorInfo = await identity_api.error2.getInfo(this.state);
        logger.error((_this$errorInfo = this.errorInfo) === null || _this$errorInfo === void 0 ? void 0 : _this$errorInfo.error);
      } catch (e) {
        logger.error(e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },

    onReturn() {
      identity_api.account2.returnRedirect(this.state);
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/consent2-mixin.js




/* harmony default export */ var consent2_mixin = ({
  mixins: [account2_mixin],

  data() {
    return {
      loading: true,
      error: false,
      concentInfo: null,
      formLoading: false,
      formError: false,
      form: {
        checkedIdentityScopes: [],
        checkedApiScopes: [],
        rememberDecision: false
      }
    };
  },

  computed: {
    concentCheckedScopes() {
      return this.form.checkedIdentityScopes.concat(this.form.checkedApiScopes);
    },

    concentClientName() {
      var _this$concentInfo$cli, _this$concentInfo;

      return (_this$concentInfo$cli = (_this$concentInfo = this.concentInfo) === null || _this$concentInfo === void 0 ? void 0 : _this$concentInfo.clientName) !== null && _this$concentInfo$cli !== void 0 ? _this$concentInfo$cli : "";
    },

    concentCanRemember() {
      var _this$concentInfo$can, _this$concentInfo2;

      return (_this$concentInfo$can = (_this$concentInfo2 = this.concentInfo) === null || _this$concentInfo2 === void 0 ? void 0 : _this$concentInfo2.canRememberConcents) !== null && _this$concentInfo$can !== void 0 ? _this$concentInfo$can : false;
    },

    concentIdentityScopes() {
      var _this$concentInfo$ide, _this$concentInfo3;

      return (_this$concentInfo$ide = (_this$concentInfo3 = this.concentInfo) === null || _this$concentInfo3 === void 0 ? void 0 : _this$concentInfo3.identityScopes) !== null && _this$concentInfo$ide !== void 0 ? _this$concentInfo$ide : [];
    },

    concentApiScopes() {
      var _this$concentInfo$api, _this$concentInfo4;

      return (_this$concentInfo$api = (_this$concentInfo4 = this.concentInfo) === null || _this$concentInfo4 === void 0 ? void 0 : _this$concentInfo4.apiScopes) !== null && _this$concentInfo$api !== void 0 ? _this$concentInfo$api : [];
    }

  },
  watch: {
    token() {
      this.fetchConcentInfo();
    }

  },
  methods: {
    async fetchConcentInfo() {
      try {
        this.loading = true;
        this.concentInfo = await identity_api.consent2.getInfo(this.token, this.state);
        this.loading = false;

        this._concentUpdateDefaultFormValues();
      } catch (e) {
        if (httpErrorIsUnauthorized(e)) {
          this.reloadRedirect();
          return;
        }

        logger.error(e);
        this.error = true;
        this.loading = false;
      }
    },

    async concentAllow() {
      try {
        this.formLoading = true;
        this.formError = false;
        await identity_api.consent2.post(this.token, this.state, this.concentCheckedScopes, this.form.rememberDecision);
        this.submitRedirect();
      } catch (e) {
        if (httpErrorIsUnauthorized(e)) {
          this.reloadRedirect();
          return;
        }

        logger.error(e);
        this.formLoading = false;
        this.formError = true;
      }
    },

    concentCancel() {
      this.formLoading = true;
      this.formError = false;
      this.returnRedirect();
    },

    _concentUpdateDefaultFormValues() {
      var _this$concentInfo$ide2, _this$concentInfo5, _this$concentInfo$api2, _this$concentInfo6;

      this.form.checkedIdentityScopes = this._concentRequiredAllScopes((_this$concentInfo$ide2 = (_this$concentInfo5 = this.concentInfo) === null || _this$concentInfo5 === void 0 ? void 0 : _this$concentInfo5.identityScopes) !== null && _this$concentInfo$ide2 !== void 0 ? _this$concentInfo$ide2 : []);
      this.form.checkedApiScopes = this._concentRequiredAllScopes((_this$concentInfo$api2 = (_this$concentInfo6 = this.concentInfo) === null || _this$concentInfo6 === void 0 ? void 0 : _this$concentInfo6.apiScopes) !== null && _this$concentInfo$api2 !== void 0 ? _this$concentInfo$api2 : []);
      this.form.rememberDecision = this.concentCanRemember;
    },

    _concentRequiredScopes(scopes) {
      return scopes.filter(s => s.required).map(s => s.name);
    },

    _concentRequiredAllScopes(scopes) {
      return scopes.map(s => s.name);
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/logout2-mixin.js




/* harmony default export */ var logout2_mixin = ({
  mixins: [account2_mixin],

  data() {
    return {
      loading: true,
      error: false,
      logoutInfo: null
    };
  },

  computed: {
    isAutoLogout() {
      var _this$logoutInfo;

      return !((_this$logoutInfo = this.logoutInfo) !== null && _this$logoutInfo !== void 0 && _this$logoutInfo.showLogoutPrompt);
    }

  },
  watch: {
    token() {
      this.fetchLogoutInfo();
    }

  },
  methods: {
    async fetchLogoutInfo() {
      try {
        this.loading = true;
        this.error = false;
        this.logoutInfo = await identity_api.logout2.getInfo(this.token, this.state);
        this.loading = false;

        if (this.isAutoLogout) {
          this.logoutRedirect();
        }
      } catch (e) {
        if (httpErrorIsUnauthorized(e)) {
          this.reloadRedirect();
          return;
        }

        logger.error(e);
        this.error = true;
        this.loading = false;
      }
    },

    onSubmitLogout() {
      this.logoutRedirect();
    },

    onCancelLogout() {
      this.returnRedirect();
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/manage2-mixin.js




/* harmony default export */ var manage2_mixin = ({
  mixins: [account2_mixin],

  data() {
    return {
      loading: true,
      error: false,
      redirecting: false,
      currentView: null,
      manageInfo: null
    };
  },

  computed: {
    wasPassword() {
      var _this$manageInfo, _this$manageInfo$info;

      return !!((_this$manageInfo = this.manageInfo) !== null && _this$manageInfo !== void 0 && (_this$manageInfo$info = _this$manageInfo.info) !== null && _this$manageInfo$info !== void 0 && _this$manageInfo$info.hasPassword);
    },

    forcedNeedChangePassword() {
      return this.needChangePassword || this.needSetPassword;
    },

    needChangePassword() {
      var _this$manageInfo2, _this$manageInfo2$man;

      return !!((_this$manageInfo2 = this.manageInfo) !== null && _this$manageInfo2 !== void 0 && (_this$manageInfo2$man = _this$manageInfo2.manage) !== null && _this$manageInfo2$man !== void 0 && _this$manageInfo2$man.needChangePassword);
    },

    needSetPassword() {
      var _this$manageInfo3, _this$manageInfo3$man;

      return !!((_this$manageInfo3 = this.manageInfo) !== null && _this$manageInfo3 !== void 0 && (_this$manageInfo3$man = _this$manageInfo3.manage) !== null && _this$manageInfo3$man !== void 0 && _this$manageInfo3$man.needSetPassword);
    }

  },
  watch: {
    token() {
      this.fetchManageInfo();
    }

  },
  methods: {
    async fetchManageInfo() {
      try {
        this.loading = true;
        this.error = false;
        this.manageInfo = await identity_api.manage2.getInfo(this.token, this.state);
        this.loading = false;
      } catch (e) {
        if (httpErrorIsUnauthorized(e)) {
          this.reloadRedirect();
          return;
        }

        logger.error(e);
        this.loading = false;
        this.error = true;
      }
    },

    onNavigate(view) {
      this.currentView = view;
    },

    onReturn() {
      this.returnRedirect();
    },

    onBack() {
      this.currentView = null;
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/manage2-password-mixin.js



/* harmony default export */ var manage2_password_mixin = ({
  mixins: [form_message_mixin],
  props: {
    token: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    wasPassword: {
      type: Boolean,
      default: false
    },
    forced: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      formSuccess: false,
      formError: false,
      showOldPassword: false,
      showNewPassword: false,
      showRepeatPassword: false,
      form: {
        oldPassword: "",
        newPassword: "",
        repeatPassword: ""
      },
      formSuccessMessage: "",
      formErrorMessage: "",
      formDefaultMessage: ""
    };
  },

  computed: {
    formIsValid() {
      let isValid = true;

      if (this.wasPassword) {
        isValid = isValid && !!this.form.oldPassword;
      }

      isValid = isValid && !!this.form.newPassword;
      isValid = isValid && !!this.form.repeatPassword;
      isValid = isValid && this.form.newPassword === this.form.repeatPassword;
      return isValid;
    },

    formMessage() {
      if (this.formSuccess) {
        return this.formSuccessMessage;
      } else if (this.formError) {
        return this.formErrorMessage;
      } else {
        return this.formDefaultMessage;
      }
    },

    descriptionType() {
      if (this.formSuccess) {
        return "success";
      } else if (this.formError) {
        return "error";
      } else {
        return "normal";
      }
    }

  },
  methods: {
    onReset() {
      this.$emit("back");
    },

    onReturn() {
      identity_api.account2.returnRedirect(this.state);
    },

    onSubmit() {
      if (this.formIsValid) {
        if (this.wasPassword) {
          const {
            oldPassword,
            newPassword
          } = this.form;
          this.changePassword(oldPassword, newPassword);
        } else {
          const {
            newPassword
          } = this.form;
          this.setNewPassword(newPassword);
        }
      }
    },

    async changePassword(oldPassword, newPassword) {
      try {
        this.loading = true;
        this.formError = false;
        this.formErrorObject = null;
        this.formSuccess = false;
        await identity_api.manage.changePassword(oldPassword, newPassword, this.token);
        this.formSuccess = true;
        this.resetForm();
      } catch (err) {
        logger.error(err);
        this.formError = true;
        this.formErrorObject = err;
      } finally {
        this.loading = false;
      }
    },

    async setNewPassword(newPassword) {
      try {
        this.loading = true;
        this.formError = false;
        this.formErrorObject = null;
        this.formSuccess = false;
        await identity_api.manage.setNewPassword(newPassword, this.token);
        this.formSuccess = true;
      } catch (err) {
        logger.error(err);
        this.formError = true;
        this.formErrorObject = err;
      } finally {
        this.loading = false;
        this.resetForm();
      }
    },

    resetForm() {
      this.form.oldPassword = "";
      this.form.newPassword = "";
      this.form.repeatPassword = "";
      this.showOldPassword = false;
      this.showNewPassword = false;
      this.showRepeatPassword = false;
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/post-logout2-mixin.js




const post_logout2_mixin_REDIRECT_DELAY = 1000;
/* harmony default export */ var post_logout2_mixin = ({
  mixins: [account2_mixin],

  data() {
    return {
      loading: true,
      error: false,
      postLogoutInfo: null,
      postLogoutRedirectDelay: post_logout2_mixin_REDIRECT_DELAY
    };
  },

  watch: {
    token() {
      this.fetchPostLogoutInfo();
    }

  },
  methods: {
    async fetchPostLogoutInfo() {
      try {
        this.loading = true;
        this.error = false;
        this.postLogoutInfo = await identity_api.logout2.getPostLogoutInfo(this.token, this.state);
        this.loading = false;
        this.$nextTick(() => {
          if (this.postLogoutInfo) {
            this.handlePostLogout(this.postLogoutInfo);
          }
        });
      } catch (e) {
        if (httpErrorIsUnauthorized(e)) {
          this.reloadRedirect();
          return;
        }

        logger.error(e);
        this.error = true;
        this.loading = false;
      }
    },

    handlePostLogout({
      frameUrl
    }) {
      if (!frameUrl) {
        this.returnRedirect();
      } else {
        this.iframePostLogout(frameUrl);
      }
    },

    iframePostLogout(frameUrl) {
      if (!this.$el) {
        this.returnRedirect();
        return;
      }

      const iframe = this._createIframe(frameUrl, () => {
        this.postLogoutRedirectWithDelay(this.postLogoutRedirectDelay);
      });

      this.$el.appendChild(iframe);
    },

    _createIframe(frameUrl, onLoad) {
      const iframe = document.createElement("iframe");
      iframe.onload = onLoad;
      iframe.src = frameUrl;
      iframe.style.width = "0px";
      iframe.style.height = "0px";
      iframe.style.display = "none";
      return iframe;
    },

    postLogoutRedirectWithDelay(delay) {
      setTimeout(() => {
        this.returnRedirect();
      }, delay);
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/account2-options-mixin.js



/* harmony default export */ var account2_options_mixin = ({
  props: {
    state: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      accountOptions: null
    };
  },

  created() {
    if (!check_redirect()) {
      this.fetchAccountOptions(this.state);
    }
  },

  methods: {
    async fetchAccountOptions(state) {
      try {
        this.accountOptions = await identity_api.account2.getOptions(state);
      } catch (e) {
        logger.error(e);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/index.js






















// CONCATENATED MODULE: ./src/utils/index.js




// CONCATENATED MODULE: ./src/index.js



// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ })

/******/ });
//# sourceMappingURL=visary-account-common-vue.common.js.map